import {type HTMLAttributes} from 'react';

import styles from './Controls.module.scss';

interface ColorPreviewProps extends HTMLAttributes<HTMLDivElement> {
  color: string;
}

export function ColorPreview({color, ...props}: ColorPreviewProps) {
  return (
    <div className={styles.colorPreview} {...props}>
      <div style={{background: color}} />
    </div>
  );
}
